"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userActivity = void 0;
exports.userActivity = [
    {
        actionType: "SUBMIT_CODES",
        invoiceGuid: null,
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: null,
        code: null,
        codeType: null,
        units: null,
        sequenceNumber: null,
        timestamp: "2022-06-09T13:58:06.000Z",
        username: "b3@example.com",
        activityType: "USER"
    },
    {
        actionType: "UPDATE_CODE",
        invoiceGuid: "97247",
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: "113494",
        code: "27284",
        codeType: "ProcedureCode",
        units: 2.0,
        sequenceNumber: null,
        timestamp: "2022-06-09T11:31:55.000Z",
        username: "b3@example.com",
        activityType: "USER"
    },
    {
        actionType: "UPDATE_CODE",
        invoiceGuid: "97247",
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: "113494",
        code: "27284",
        codeType: "ProcedureCode",
        units: 3.0,
        sequenceNumber: null,
        timestamp: "2022-06-09T10:50:40.000Z",
        username: "b3@example.com",
        activityType: "USER"
    },
    {
        actionType: "REMOVE_CODE",
        invoiceGuid: "97247",
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: "113494",
        code: "QC",
        codeType: "ModifierCode",
        units: null,
        sequenceNumber: 1,
        timestamp: "2022-06-09T10:50:36.000Z",
        username: "b3@example.com",
        activityType: "USER"
    },
    {
        actionType: "ADD_CODE",
        invoiceGuid: "97247",
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: "113494",
        code: "ACT",
        codeType: "ModifierCode",
        units: null,
        sequenceNumber: 2,
        timestamp: "2022-06-09T10:50:35.000Z",
        username: "b3@example.com",
        activityType: "USER"
    },
    {
        actionType: "ADD_CODE",
        invoiceGuid: "97247",
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: "113494",
        code: "QC",
        codeType: "ModifierCode",
        units: null,
        sequenceNumber: 1,
        timestamp: "2022-06-09T10:50:29.000Z",
        username: "b3@example.com",
        activityType: "USER"
    },
    {
        actionType: "REMOVE_CODE",
        invoiceGuid: "97247",
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: "113494",
        code: "LT",
        codeType: "ModifierCode",
        units: null,
        sequenceNumber: 1,
        timestamp: "2022-06-09T10:50:22.000Z",
        username: "b3@example.com",
        activityType: "USER"
    },
    {
        actionType: "ADD_CODE",
        invoiceGuid: "97247",
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: "113494",
        code: "LT",
        codeType: "ModifierCode",
        units: null,
        sequenceNumber: 1,
        timestamp: "2022-06-09T01:55:25.000Z",
        username: "b3@example.com",
        activityType: "USER"
    },
    {
        actionType: "REMOVE_CODE",
        invoiceGuid: "97247",
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: "113494",
        code: "LT",
        codeType: "ModifierCode",
        units: null,
        sequenceNumber: 1,
        timestamp: "2022-06-09T01:55:08.000Z",
        username: "b3@example.com",
        activityType: "USER"
    },
    {
        actionType: "UPDATE_CODE",
        invoiceGuid: "97247",
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: "113494",
        code: "27284",
        codeType: "ProcedureCode",
        units: 1.0,
        sequenceNumber: null,
        timestamp: "2022-06-09T00:56:12.000Z",
        username: "b3@example.com",
        activityType: "USER"
    },
    {
        actionType: "UPDATE_CODE",
        invoiceGuid: "97247",
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: "113494",
        code: "27284",
        codeType: "ProcedureCode",
        units: 2.0,
        sequenceNumber: null,
        timestamp: "2022-06-09T00:54:14.000Z",
        username: "b3@example.com",
        activityType: "USER"
    },
    {
        actionType: "REMOVE_CODE",
        invoiceGuid: "97247",
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: "113494",
        code: "59",
        codeType: "ModifierCode",
        units: null,
        sequenceNumber: 2,
        timestamp: "2022-06-09T00:50:36.000Z",
        username: "b3@example.com",
        activityType: "USER"
    },
    {
        actionType: "ADD_CODE",
        invoiceGuid: "97247",
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: "113494",
        code: "59",
        codeType: "ModifierCode",
        units: null,
        sequenceNumber: 2,
        timestamp: "2022-06-09T00:50:09.000Z",
        username: "b3@example.com",
        activityType: "USER"
    },
    {
        actionType: "REMOVE_CODE",
        invoiceGuid: "97247",
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: "113494",
        code: "GC",
        codeType: "ModifierCode",
        units: null,
        sequenceNumber: 1,
        timestamp: "2022-06-09T00:50:06.000Z",
        username: "b3@example.com",
        activityType: "USER"
    },
    {
        actionType: "ADD_CODE",
        invoiceGuid: "97247",
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: "113494",
        code: "LT",
        codeType: "ModifierCode",
        units: null,
        sequenceNumber: 2,
        timestamp: "2022-06-09T00:50:02.000Z",
        username: "b3@example.com",
        activityType: "USER"
    },
    {
        actionType: "ADD_CODE",
        invoiceGuid: "97247",
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: "113494",
        code: "27284",
        codeType: "ProcedureCode",
        units: 1.0,
        sequenceNumber: null,
        timestamp: "2022-06-09T00:47:42.000Z",
        username: "b3@example.com",
        activityType: "USER"
    },
    {
        actionType: "REMOVE_CODE",
        invoiceGuid: "97247",
        updatedInvoiceFieldName: null,
        updatedInvoiceFieldValue: null,
        transactionGuid: "113494",
        code: "A01.2",
        codeType: "DiagnosisCode",
        units: null,
        sequenceNumber: 1,
        timestamp: "2022-06-09T00:35:35.000Z",
        username: "b3@example.com",
        activityType: "USER"
    }
];
//# sourceMappingURL=user-activity.js.map